import styled from "styled-components";

export const Card = styled.div`
  > div {
    display: flex;
    margin: 25px 0px 25px -15px;
    color: var(--text-opacity);
    font-weight: bold;
    font-size: 16px;
    gap: 20px;
    p {
      display: none;
    }
  }

  > div:nth-child(2) {
    align-items: center;
  }
`

export const Title = styled.div`
  width: 100%;
  border-top: 1px solid var(--line-opacity);
  > h6 {
    font-size: 19px;
    color: var(--text-opacity);
    margin-bottom: -35px;
    padding-top: 20px;
  }
`
